<template>
    <div class="block-editor zoho-add-attachment">
        <div class="wrapper">
            <section>
                <div class="title">Zoho Module Name</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type zoho module name"
                        :show-attributes="false"
                        :show-emoji="false"
                        v-model="clone.module"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">Record Id</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type record id of given module"
                        :show-attributes="true"
                        :show-emoji="false"
                        v-model="clone.recordId"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">File URL</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Attach file from URL"
                        :show-attributes="true"
                        :show-emoji="false"
                        v-model="clone.url"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">File Name</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="file name"
                        :show-attributes="true"
                        :show-emoji="false"
                        v-model="clone.filename"
                        automation-mode
                    />
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("ZohoAddAttachmentToRecord");
export default {
    name: "ZohoAddAttachmentToRecord",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.zoho-add-attachment {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>
